import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';

export const saveOCClaim = createProvider(api.saveOCClaim)
  .andThen((res) => res)
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Save OC claim aborted');
    } else {
      console.error('Save OC claim was failed:', error);
    }
    throw error;
  });
